import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=f82204f2&scoped=true&"
import script from "./InputText.vue?vue&type=script&lang=js&"
export * from "./InputText.vue?vue&type=script&lang=js&"
import style0 from "./InputText.vue?vue&type=style&index=0&id=f82204f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82204f2",
  null
  
)

export default component.exports